import React, { useContext, useState, useEffect } from 'react'
import { Link, Outlet } from 'react-router-dom'
import { LoginContext } from '../context/LoginContext'
import { siteDetailsContext } from "../context/SiteDetailsContext";
import { SelectSiteContext } from "../context/SelectSite";

export default function ProfileLayout() {

    const { logoutUser } = useContext(LoginContext)
    const { siteDetails } = useContext(siteDetailsContext);
    const { setSiteIdFunction } = useContext(SelectSiteContext);
    const id = localStorage.getItem('currentSideId')
    const [siteId, setSiteId] = useState(id);

    useEffect(() => {
        var subscribed = true;
        localStorage.setItem('currentSideId', siteId)
        setSiteIdFunction(siteId)
        return (() => {
            subscribed = false;
        })
    }, [siteId])

    return (
        <>
            <main className="main" id="top">
                <div className="container-fluid">
                    <nav className="navbar navbar-light navbar-glass fs--1 font-weight-semi-bold row navbar-top sticky-kit navbar-expand">
                        <div className="dropdown sites-dropdown text-sans-serif">
                            <button className="btn  dropdown-toggle" id="dropdownSiteButton" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Select Site&nbsp;&nbsp;
                                <svg className="SVGInline-svg SVGInline--cleaned-svg SVG-svg Icon-svg Icon--chevronDown-svg SVG--color-svg SVG--color--gray600-svg" style={{ width: '12px', height: '12px' }} height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.591 5.293a1 1 0 0 1 1.416 1.416l-6.3 6.3a1 1 0 0 1-1.414 0l-6.3-6.3A1 1 0 0 1 2.41 5.293L8 10.884z" fillRule="evenodd" />
                                </svg>
                            </button>
                            <div className="dropdown-menu dropdown-menu-left py-0" aria-labelledby="dropdownSiteButton">
                                <input type="text" className="form-control filter-sites" placeholder="Filter by name..." style={{ margin: '-1px 0', border: 'none' }} />
                                {
                                    siteDetails.map((value) => {
                                        const { _id, siteName, icon } = value;
                                        return (
                                            <div key={_id}>
                                                <div className="dropdown-divider" />
                                                <div onClick={() => setSiteId(_id)} className="dropdown-item">
                                                    <img alt='img' src={icon} />
                                                    {siteName}</div>
                                            </div>
                                        )
                                    })
                                }
                                <div className="dropdown-divider" />
                                <Link className="dropdown-item text-primary" to="/account/add-site">
                                    <img alt='img' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjAQMAAAAkFyEaAAAABlBMVEUse+X///+6FDpEAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAFUlEQVQImWNgoAkwQCcZ/2EXpz4AAN+KAiD4IY0wAAAAAElFTkSuQmCC" />            Add New Site
                                </Link>
                                <div className="dropdown-divider" />
                            </div>
                        </div>
                        <style dangerouslySetInnerHTML={{ __html: "\n   #notificationsImprovments .notification{flex-wrap:wrap;}\n   .loading-preview{    flex: 0 0 100%;display: block;text-align: center; padding:20px 0}\n   .loading-preview .page-loader{display:inline-block}\n   #notificationsImprovments .list-group-item .notification-flush{padding:.5rem 1rem}\n   #notificationsImprovments .dropdown-menu {\n      overflow-y: auto;\n   }   \n   #rpc .notification{\n      align-items: center;\n      justify-content: space-between;      \n   }\n   .prc-loader > div{display:inline-block;}\n   .rpc-stats, .rpc-no-stats{display:none}\n   #navbarDropdownRevenue:hover .revenue-icon-bottom{fill:#000;}\n   #rpc.show svg{fill:#5292e8 !important;}\n" }} />
                        <div className="collapse navbar-collapse" id="navbarNavDropdown1">
                            <ul className="navbar-nav align-items-center ml-auto">
                                <li>
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link pr-0" id="navbarDropdownUser" href="/" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <div className="avatar avatar-xl" style={{ fontSize: '34px', marginTop: '-12px' }}>
                                            <i className="fas fa-user-circle" />
                                        </div>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right py-0 nav-user-dropdown" aria-labelledby="navbarDropdownUser">
                                        <div className="bg-white rounded-soft py-2">
                                            <Link className="dropdown-item" to="/account/profile">Profile &amp; account</Link>
                                            <Link className="dropdown-item" to="/account/team-members">Team Members</Link>
                                            <div className="dropdown-divider" />
                                            {/* <Link className="dropdown-item" to="/account/invoice" >Billing History</Link> */}
                                            <Link className="dropdown-item" to="/account/wallet">Billing History</Link>
                                            <Link className="dropdown-item" to="/account/plans" >Plans</Link>
                                            <div className="dropdown-divider" />
                                            <div onClick={logoutUser} className="dropdown-item cursor-pointer">Logout</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    <Outlet />
                </div>
            </main>
        </>
    )
}
